var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }